// ✅ Semua import harus di atas
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import axios from "axios";
import "./index.css";

// ✅ jQuery dulu
import $ from "jquery";

// ✅ DataTables JS & CSS
import "datatables.net-dt"; // JS
import "datatables.net-dt/css/dataTables.dataTables.css"; // CSS

// Assign jQuery ke window supaya bisa dipakai global
window.$ = window.jQuery = $;

// Konfigurasi Axios
axios.defaults.withCredentials = true;

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
